import { cloneDeep } from 'lodash';

const defaultRxManagerFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};
const defaultPOFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'poid',
  filters: [],
};
const defaultPrescriberFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};
const defaultClaimsFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'drugId',
  filters: [],
};
const defaultInventoryFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};


const defaultAdvancceReportsFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'ceid',
  filters: [],
};

const defaultconfigurationFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'contractId',
  filters: [],

};

const defaultPharmacyFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};

const defaultviewbinFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};

const defaultaddBINFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'bin',
  filters: [],
};

const defaultDrugCatalogFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};
const defaultDrugExclusionFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};
const defaultOrderExclusionFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};
const defaultOverrideFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};

const defaultPatientFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
}
const defaultaudittoolFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'asc',
  orderBy: 'auditItemID',
  filters: [],

}

const defaultStates = {
  prescriber: {
    hasFilterd: false,
    search: cloneDeep(defaultPrescriberFilter),
    coveredEntities: [],
    searchTerms: {
      coveredEntityIDs: {}
    }
  },
  purchaseOrder: {
    hasFilterd: false,
    search: cloneDeep(defaultPOFilter),
    coveredEntities: [],
    chainPharmacies: [],
    pharmacies: [],
    coveredEntity: {},
    chainPharmacy: {},
    wholesalers: {},
    searchTerms: {
      coveredEntityIDs: {},
      chainPharmacyIds: {},
      pharmacyIds: {},
      poNumber: '',
      invoiceNumber: '',
      showClaimID: '',
      orderStatusId: '',
      wholesalerId: '',
      startDate: '',
      endDate: '',
      claimTypeId: ''
    }
  },

  rxManager: {
    hasFilterd: false,
    search: cloneDeep(defaultRxManagerFilter),
    coveredEntities: [],
    chainPharmacies: [],
    pharmacies: [],
    coveredEntity: {},
    chainPharmacy: {},
    searchTerms: {
      coveredEntityIDs: {},
      rxNumber: '',
      startDate: '',
      endDate: '',
      showClaimID: '',
      chainPharmacyIds: {},
      pharmacyIds: {},
      claimTypeId: ''
    },
  },
  dashboard: {
    hasFilterd: false,
    search: [],
    coveredEntities: [],
    chainPharmacies: [],
    pharmacies: [],
    dateRange: {},
    searchTerms: {
      coveredEntityIDs: {},
      chainPharmacyIds: {},
      pharmacyIds: {},
      dateRangeID: 4,
    },
  },
  inventory: {
    hasFilterd: false,
    search: cloneDeep(defaultInventoryFilter),
    coveredEntities: [],
    chainPharmacies: [],
    pharmacies: [],
    coveredEntity: {},
    chainPharmacy: {},
    pharmacy: {},
    searchTerms: {
      coveredEntityIDs: {},
      chainPharmacyIds: {},
      pharmacyIds: {},
      ndc: '',
      showClaimID: '',
    },
  },

  configuration: {
    hasFilterd: false,
    search: cloneDeep(defaultconfigurationFilter),
    coveredEntity: {},
    coveredEntities: [],
    searchTerms: {
      coveredEntityID: '',
      coveredEntityName: '',
      ordering: '',
      showClaimID: '',
    },
  },

  advanceReport: {
    hasFilterd: false,
    search: cloneDeep(defaultAdvancceReportsFilter),
    coveredEntities: [],
    chainPharmacies: [],
    pharmacies: [],
    coveredEntity: {},
    chainPharmacy: {},
    selectedReportType: {},
    selectedClaimType: {},
    selectedStatusType: {},
    selectedDateRange: {},
    selectedDateQualify: {},
    dateRange: {},
    searchTerms: {
      coveredEntityIDs: {},
      reportType: 1,
      dateRangeID: 1,
      startDate: '',
      endDate: '',
      showClaimID: '',
      chainPharmacyIds: {},
      pharmacyIds: {},
      claimTypeId: '',
      statusTypeId: '',
      dateQualifyId: ''
    },
  },
  pharmacyreports: {
    hasFilterd: false,
    search: cloneDeep(defaultPharmacyFilter),
    pharmacies: [],
    dateRange: {},
    searchTerms: {
      pharmacyIDs: [],
      showClaimID: '',
      dateRangeID: 1,
      startDate: '',
      endDate: ''
    },
  },
  viewbin: {
    hasFilterd: false,
    search: cloneDeep(defaultviewbinFilter),
    coveredEntities: [],
    chainPharmacies: [],
    pharmacies: [],
    coveredEntity: {},
    chainPharmacy: {},
    selectedResonDropdown: {},
    selectedLevelDropdown: {},
    searchTerms: {
      coveredEntityIDs: [],
      chainPharmacyIds: {},
      pharmacyIds: {},
      selectedLevelOpt: {},
      selectedResonOpt: {},
      binNumber: '',
    },
  },
  addBIN: {
    hasFilterd: false,
    search: cloneDeep(defaultaddBINFilter),
    coveredEntities: [],
    chainPharmacies: [],
    pharmacies: [],
    coveredEntity: {},
    chainPharmacy: {},
    selectedResonList: {},
    selectedLevelList: {},
    searchTerms: {
      coveredEntityIDs: {},
      chainPharmacyIds: {},
      pharmacyIds: {},
      selectedLevelOptions: {},
      selectedResonOptions: {},
      state: {},
    },
  },
  drugCatalog: {
    hasFilterd: false,
    search: cloneDeep(defaultDrugCatalogFilter),
    coveredEntities: [],
    pharmacies: [],
    wholesalersData: [],
    accountnumberData: [],
    coveredEntity: {},
    wholesalers: {},
    searchTerms: {
      coveredEntityIDs: {},
      pharmacyIds: {},
      wholesalerId: '',
      ndc: '',
      WholesalerAccountID: '',
      WholesalerAccount: {},
      accountType: '',
      WholesalerAccountCodes: []
    }
  },
  drugExclusion: {
    hasFilterd: false,
    search: cloneDeep(defaultDrugExclusionFilter),
    coveredEntities: [],
    pharmacies: [],
    wholesalersData: [],
    accountnumberData: [],
    coveredEntity: {},
    wholesalers: {},
    searchTerms: {
      coveredEntityIDs: {},
      pharmacyIds: {},
      wholesalerId: '',
      ndc: '',
      WholesalerAccountID: '',
      WholesalerAccount: {},
      accountType: '',
      WholesalerAccountCodes: []
    }
  },
  orderExclusion: {
    hasFilterd: false,
    search: cloneDeep(defaultOrderExclusionFilter),
    coveredEntities: [],
    pharmacies: [],
    wholesalersData: [],
    accountnumberData: [],
    coveredEntity: {},
    wholesalers: {},
    searchTerms: {
      coveredEntityIDs: {},
      pharmacyIds: {},
      wholesalerId: '',
      ndc: '',
      WholesalerAccountID: '',
      WholesalerAccount: {},
      accountType: '',
      WholesalerAccountCodes: []
    }
  },
  overrideExclusion: {
    hasFilterd: false,
    search: cloneDeep(defaultOverrideFilter),
    coveredEntities: [],
    pharmacies: [],
    coveredEntity: {},
    searchTerms: {
      coveredEntityIDs: {},
      pharmacyIds: {},
      ndc: '',
      //selectedExclusion: '',
    }
  },
  patient: {
    hasFilterd: false,
    search: cloneDeep(defaultPatientFilter),
    coveredEntities: [],
    personData: [],
    coveredEntity: {},
    persons: {},
    searchTerms: {
      coveredEntityIDs: {},
      personIDs: {},
      person: ''
    },
  },
  audittool: {
    hasFilterd: false,
    search: cloneDeep(defaultaudittoolFilter),
    coveredEntities: [],
    chainPharmacies: [],
    pharmacies: [],
    coveredEntity: {},
    chainPharmacy: {},
    pharmacy: {},
    searchTerms: {
      coveredEntityID: '',
      coveredEntityName: '',
      chainPharmacyIds: {},
      pharmacyIds: {},
      startDate: '',
      endDate: '',
      count: null,
      percent: null,
      auditCriteria: null,
      criteriaSelected: null,
      payor: null,
      prescriber: null,
    },
  },

};


const initialStates = {
  loading: false,
  rxManager: cloneDeep(defaultStates.rxManager),
  prescriber: cloneDeep(defaultStates.prescriber),
  drugCatalog: cloneDeep(defaultStates.drugCatalog),
  drugExclusion: cloneDeep(defaultStates.drugExclusion),
  overrideExclusion: cloneDeep(defaultStates.overrideExclusion),
  inventory: cloneDeep(defaultStates.inventory),
  purchaseOrder: cloneDeep(defaultStates.purchaseOrder),
  dashboard: cloneDeep(defaultStates.dashboard),
  advanceReport: cloneDeep(defaultStates.advanceReport),
  configuration: cloneDeep(defaultStates.configuration),
  pharmacyreports: cloneDeep(defaultStates.pharmacyreports),
  viewbin: cloneDeep(defaultStates.viewbin),
  addBIN: cloneDeep(defaultStates.addBIN),
  drugExclusion: cloneDeep(defaultStates.drugExclusion),
  orderExclusion: cloneDeep(defaultStates.orderExclusion),
  patient: cloneDeep(defaultStates.patient),
  audittool: cloneDeep(defaultStates.audittool),
};

export { initialStates, defaultStates };
